<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="criterePondere.critere"
    [label]="step3.getcritere" [type]="'text'" [rule]="'minSize_3|maxSize_1000'" [errorMessage]="{'minLength' : 'ctr_29'}"[name]="getUid() + '_SepAtt_critere'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="criterePondere.criterePCT"
    [label]="step3.getcriterepct" [type]="'number'" [rule]="'min_1|max_99'" [name]="getUid() + '_SepAtt_criterePCT'">
</app-form-input>
